export { default } from "./SimpleFacets";
